import { cn } from "@/lib/utils";
import { BLOG_STATUS_CONFIG } from "@/lib/status-configs";
import { FileText } from "@phosphor-icons/react";
import type { BlogStatusFilter } from "./BlogFilterTabs";

const STATUS_CONFIG = BLOG_STATUS_CONFIG;

export function BlogEmptyState({
  status,
  hasSearch,
}: {
  status: BlogStatusFilter;
  hasSearch: boolean;
}) {
  const config = status
    ? STATUS_CONFIG[status as keyof typeof STATUS_CONFIG]
    : null;
  const Icon = config?.icon || FileText;

  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border/60 bg-muted/20 px-6 py-16 text-center">
      <div
        className={cn(
          "mb-4 flex size-16 items-center justify-center rounded-2xl",
          config?.bg || "bg-muted/40"
        )}
      >
        <Icon className={cn("size-7", config?.color || "text-muted-foreground")} />
      </div>
      <h3
        className="text-lg font-semibold text-foreground"
        style={{ fontFamily: "var(--font-heading)" }}
      >
        {hasSearch ? "Nema rezultata pretrage" : "Nema članaka"}
      </h3>
      <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">
        {hasSearch
          ? "Pokušajte s drugačijim pojmom za pretragu."
          : status === "pending"
            ? "Nema članaka koji čekaju odobrenje."
            : status === "published"
              ? "Još nema objavljenih članaka."
              : status === "draft"
                ? "Nema nacrta članaka."
                : status === "rejected"
                  ? "Nema odbijenih članaka."
                  : "Kreirajte prvi članak klikom na \"Novi članak\"."}
      </p>
    </div>
  );
}
